<template>
  <div class="preview-column pa-6">
    <div class="preview-header">
      <h3 class="section-title mb-2 text-title-medium">
        {{ $t('content-creator.office-selection.preview-selection') }}
      </h3>
      <p class="preview-subtitle text-title-small mb-4">
        {{ $t('content-creator.office-selection.selected-offices') }}
      </p>
    </div>

    <div class="selected-offices-scrollable">
      <span
        v-if="includeHeadOffice"
        class="office-badge"
      >
        {{ $t('content-creator.office-selection.head-office') }}
      </span>

      <span
        v-for="office in selectedOffices"
        :key="office.id"
        class="office-badge text-body-medium"
      >
        {{ office.office }}
      </span>

      <div
        v-if="!includeHeadOffice && selectedOffices.length === 0"
        class="empty-selection"
      >
        <v-icon
          size="48"
          color="grey-lighten-1"
        >
          mdi-office-building-outline
        </v-icon>
        <div class="mt-3 text-grey text-body-medium">
          {{ $t('content-creator.office-selection.no-offices-selected') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Office } from '../composables/useOfficeSelection'

interface Props {
  selectedOffices: Office[]
  includeHeadOffice: boolean
}

defineProps<Props>()
</script>

<style scoped>
.preview-column {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-left: 1px solid #add3d2;
  overflow: hidden;
  flex: 1 1 0;
}

.preview-header {
  flex-shrink: 0;
  flex-grow: 0;
}

.section-title {
  color: rgba(var(--v-theme-on-surface));
}

.preview-subtitle {
  color: rgba(var(--v-theme-on-surface));
}

.selected-offices-scrollable {
  flex: 1 1 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-content: flex-start;
  min-height: 0;
}

.office-badge {
  display: inline-flex;
  align-items: center;
  background-color: #e5eefd;
  color: rgba(var(--v-theme-on-surface));
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 100px;
  gap: 6px;
  opacity: 1;
  min-height: 30px;
}

.empty-selection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 48px 24px;
  text-align: center;
}
</style>
